<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="85%"
            height="100%"
            class="modalDialog"
            no-click-animation
        >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle title="予約状況詳細" />
                    <v-container class="mb-2 titleContainer">
                        <v-row>
                            <v-col
                                class="title"
                                cols="4">
                                <span class="mr-12 font-weight-bold">予約番号</span>
                                {{ detailInfo.reserve_no }}
                            </v-col>
                        </v-row>
                    </v-container>
                    <twoColumnTable
                        v-if="input.totalFee.toLocaleString() !== '0'"
                        title="料金"
                        :cellData="FeeDetail"
                        />
                    <twoColumnTable
                        title="プラン詳細"
                        :cellData="planDetailInfo" />
                    <v-card-actions>
                        <v-btn
                            x-large
                            v-if="input.planId != 0"
                            color="deep-orange"
                            :disabled="isCanceled || btn[2].isActive"
                            @click="displayRemoveOverLay"
                        >
                            予約取消
                        </v-btn>
                        <v-btn
                            :class="{'ml-6': input.planId != 0}"
                            x-large
                            color="primary"
                            :disabled="isCanceled || btn[3].isActive"
                            @click="showChange"
                        >
                            変更設定
                        </v-btn>
                        <div class="reserveChangeBtnWrap" v-if="changeReserveFlag === false">
                            <v-btn
                                x-large
                                v-if="input.planId != 0"
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="displayUpdateDialog"
                                >日付変更
                            </v-btn>
                            <v-btn
                                x-large
                                v-if="input.planId != 0"
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="displaySelectPlanList"
                                >プラン変更
                            </v-btn>
                            <v-btn
                                x-large
                                v-if="input.planId != 0"
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="timeDialogOpen"
                                >枠選択・組追加
                            </v-btn>
                            <v-btn
                                x-large
                                v-if="input.planId != 0"
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="displayCompanion('deleteCompanion')"
                                >組削除
                            </v-btn>
                            <v-btn
                                x-large
                                v-if="input.planId != 0"
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="displayCompanion('changeCompanionNumber')"
                                >人数変更
                            </v-btn>
                            <v-btn
                                x-large
                                color="primary"
                                class="px-2"
                                :disabled="isCanceled || btn[3].isActive"
                                @click="displayCompanion('changeCompanion')"
                                >同伴者
                            </v-btn>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                            x-large
                            v-if="chatboxSetting"
                            :disabled="btn[1].isActive"
                            color="primary"
                            @click="displayMessageDialog">
                            Chatbox
                        </v-btn>
                        <v-btn
                            x-large
                            v-if="display_course_flag"
                            color="warning"
                            :disabled="btn[1].isActive"
                            @click="openChangeOverlay">
                                <span v-if="display_course === 1" value="1">コース表示中</span>
                                <span v-else value="0">コース非表示</span>
                        </v-btn>
                        <v-btn
                            x-large
                            color="blue-grey lighten-5"
                            @click="CloseModal">
                            閉じる
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <RemoveOverLay
                    page-name="予約"
                    @processing="cancelReserve"
                    @cancel="closeRemoveOverLay"
                    :process-result="process"
                    :overlay-switch="removeOverlay"
                />
                <ReserveUpdate
                    ref="UpdateListView"
                    :received="update"
                    @refresh="refresh"
                    @refresh-event="getReserveDetail"
                />
                <MessageList
                    ref="MessageListView"
                    :received="passTo"
                    :adminInfo="adminInfo"
                    :golfCourseSelection="golfCourseSelection"
                    @close="CloseModal" />
                <changeOverLay
                    page-name="コース名表示"
                    @processing="updateComplete"
                    @cancel="closeChangeOverlay"
                    :process-result="process"
                    :OverlaySwitch="changeOverLay"
                />
                <SelectPlanList
                    :received="update"
                    :planDialog="planDialog"
                    @success="successCompanionOpen($event)"
                    @close="closePlanList"
                    ref="SelectPlanModal"
                />
                <Companion
                    ref="CompanionDialogView"
                    @close-companion="closeCompanionModal"
                    @add-start-time="selectCellDialogOpen($event)"
                    v-show="companionDialog"
                />
                <StartTimeSelect
                    ref="StartTimeModal"
                    :received="update"
                    :childDialog="timeDialog"
                    @success="successClose($event)"
                    @close="closeChild"
                />
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import RemoveOverLay from '@/components/overlay/RemoveOverlay';
import ReserveUpdate from './ReserveUpdate';
import twoColumnTable from '@/components/table/twoColumnTable';
import MessageList from '@/views/Message/MessageList';
import { authorityMixin } from '@/views/authorityMixin';
import { RESERVE_USE_POINT_CANCEL } from '@/constants/point_register';
import {
    GET_RESERVE,
    CANCEL_RESERVE,
    UPDATE_DISPLAY_COURSE } from '@/constants/reserve';
import changeOverLay from '@/components/overlay/ChangeOverlay';
import Companion from './Companion';
import SelectPlanList from './SelectPlanList';
import StartTimeSelect from './StartTimeSelect';

export default {
    components: {
        CardTitle,
        ReserveUpdate,
        twoColumnTable,
        RemoveOverLay,
        MessageList,
        changeOverLay,
        Companion,
        SelectPlanList,
        StartTimeSelect
    },
    props: [
        'detailInfo',
        'adminInfo',
        'golfCourseSelection',
        'chatboxSetting'
    ],
    mixins: [
        authorityMixin
    ],
    data () {
        return {
            // 削除ダイアログ
            removeOverlay: false,
            // ダイアログの表示値
            dialog: false,
            golfCode: '',
            // 入力値
            input: {
                cellId: '',
                planId: '',
                planName: '',
                golfCode: '',
                golfName: '',
                totalFee: '',
                playDate: '',
                courseName: '',
                playStart: '',
                playerMin: '',
                playerMax: '',
                playerLeft: '',
                addFee2bWeekday: '0',
                addFee2bWeekend: '0',
                addFee3bWeekday: '0',
                addFee3bWeekend: '0',
                groupinfo: [],
                playStyle: [],
                detail: '',
                telephone: '',
                reserveType: 0,
                playNumber: '',
                memberClass: 0,
                reserveSituation: 0,
                cancelDetail: '',
                requestFirstChoice: null,
                requestSecondChoice: null,
                requestThirdChoice: null,
                requestContactInfo: null,
                displayCourse: 0
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: ''
            },
            // メッセージ画面に渡す情報
            passTo: {
                golfCode: '',
                reserve_no: ''
            },
            // 変更画面に渡す情報
            update: {
                planId: '',
                cellId: '',
                cellNumber: '',
                groupNum: 0,
                golfCode: '',
                playerMin: '',
                playerMax: '',
                memberNo: '',
                playDate: '',
                playerLeft: '',
                planName: '',
                telephone: '',
                reserveNo: '',
                playNumber: '',
                memberClass: 0,
                reserveType: 0,
                requestFirstChoice: null,
                requestSecondChoice: null,
                requestThirdChoice: null,
                requestContactInfo: null
            },
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: 'メッセージ確認', isActive: true },
                { element_id: '002', element_name: '予約取消', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true }
            ],
            vue_id: 'SCR0016',
            changeOverLay: false,
            // 表示、非表示変更情報
            from_set_data: {
                reserveNo: ''
            },
            // 対応完了フラグ
            display_course: 0,
            displayingCd: 1,
            notReserveNo: '000000000000',
            planDialog: false,
            timeDialog: false,
            visitedDialog: false,
            // クラシックでコース名表示設定を表示するフラグ
            display_course_flag: process.env.VUE_APP_NAME === 'hcgc',
            changeReserveFlag: true,
            editContents: '',
            companionDialog: false
        };
    },
    /** --------------------------------------------
    * 予約一覧からデータが渡ってきた際に表示処理
    * -------------------------------------------- */
    watch: {
        'detailInfo.reserve_no' () {
            this.admin.user_id = this.adminInfo.user_id;
            this.getAuthorityList();
            this.getReserveDetail();
        }
    },
    /** --------------------------------------------
    * 開く際にモーダルのスクロールを上部に移動させる。
    * -------------------------------------------- */
    // updated () {
    //     const elements = document.getElementsByClassName('v-dialog--active');
    //     if (!elements || !elements.length) {
    //     // 要素が取得できなかった場合は終了
    //         return;
    //     }
    //     elements[0].scrollTop = 0;
    // },
    computed: {
        isCanceled () {
            return this.input.reserveSituation === '4';
        },
        /** ----------------------------------------------
         * 料金のデータを整形
         * ---------------------------------------------- */
        FeeDetail () {
            return [
                { name: 'お一人様料金', value: this.input.totalFee.toLocaleString() },
                { name: '平日2サム割増', value: this.input.addFee2bWeekday.toLocaleString(), three: true, first: true },
                { name: '休日2サム割増', value: this.input.addFee2bWeekend.toLocaleString(), three: true },
                { name: '平日3サム割増', value: this.input.addFee3bWeekday.toLocaleString(), three: true },
                { name: '休日3サム割増', value: this.input.addFee3bWeekend.toLocaleString(), three: true },
                { name: 'キャンセル', value: this.input.cancelDetail }
            ];
        },
        /** ----------------------------------------------
         * 予約情報のデータを整形
         * ---------------------------------------------- */
        planDetailInfo () {
            if (this.input.totalFee.toLocaleString() === '0') {
                return [
                    { name: 'プレー日', value: this.dateFormated(this.input.playDate) },
                    { name: 'スタート時間', value: this.timeFormated(this.input.playStart) },
                    { name: '組数', value: `${this.input.cellNumber}組` },
                    { name: 'プレー人数', value: `${this.input.playNumber}人` },
                    { name: 'プレースタイル', value: this.input.playStyle, arrayType: 'playStyle' },
                    { name: 'キャンセル', value: this.input.cancelDetail }
                ];
            } else {
                return [
                    { name: 'プラン名', value: this.input.planName },
                    { name: 'ゴルフ場名', value: this.input.golfName },
                    { name: 'プレー日', value: this.dateFormated(this.input.playDate) },
                    { name: 'コース', value: this.input.courseName },
                    { name: 'スタート時間', value: this.timeFormated(this.input.playStart) },
                    { name: '組数', value: `${this.input.cellNumber}組` },
                    { name: 'プレー人数', value: `${this.input.playNumber}人` },
                    { name: 'プレースタイル', value: this.input.playStyle, arrayType: 'playStyle' },
                    { name: 'プラン詳細', value: this.input.detail }
                ];
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 日付の表示を修正
         * ---------------------------------------------- */
        dateFormated (data) {
            const date = data.split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
        /** ----------------------------------------------
         * 時間の表示を修正
         * ---------------------------------------------- */
        timeFormated (data) {
            const time = data.split(':');
            return time[0] + ':' + time[1];
        },
        /** ----------------------------------------------
         * キャメルケースに変換
         * ---------------------------------------------- */
        toCamelCase (str) {
            return str.split('_').map((str, index) => {
                if (index === 0) {
                    return str.toLowerCase();
                }
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            }).join('');
        },
        /** --------------------------------------------
        * 予約情報を取得
        * -------------------------------------------- */
        async getReserveDetail () {
            this.$apollo.mutate({
                mutation: GET_RESERVE,
                variables: {
                    reserve_no: this.detailInfo.reserve_no
                }
            }).then(res => {
                const data = res.data.GetReserveDetailFromAdmin.Reserve;
                Object.keys(data).forEach(el => {
                    const camelCase = this.toCamelCase(el);
                    this.$set(this.input, camelCase, data[el]);
                });
                // クラシックの場合
                if (process.env.VUE_APP_NAME === 'hcgc') {
                    this.input.playStyle.some_code = 9;
                }
                // カート
                this.input.playStyle.cart_code.forEach(element => {
                    switch (element) {
                    case 1:
                        this.input.playStyle.cartCode1 = true;
                        break;
                    case 2:
                        this.input.playStyle.cartCode2 = true;
                        break;
                    case 3:
                        this.input.playStyle.cartCode3 = true;
                        break;
                    case 4:
                        this.input.playStyle.cartCode4 = true;
                        break;
                    case 5:
                        this.input.playStyle.cartCode5 = true;
                        break;
                    case 6:
                        this.input.playStyle.cartCode6 = true;
                        break;
                    case 7:
                        this.input.playStyle.cartCode7 = true;
                        break;
                    case 8:
                        this.input.playStyle.cartCode8 = true;
                        break;
                    case 10:
                        this.input.playStyle.cartCode10 = true;
                        break;
                    }
                });

                this.input.playStyle.cart_code = [this.input.playStyle.cart_code];

                // ボタン切り替え
                this.display_course = this.input.displayCourse;

                this.updateInfoRefresh();
            });
        },
        /** --------------------------------------------
        * 予約情報をキャンセル
        * -------------------------------------------- */
        cancelReserve: async function () {
            this.process.result = '1';
            this.process.resultText = '処理中です。';
            this.$apollo.mutate({
                mutation: CANCEL_RESERVE,
                variables: {
                    reserve_no: this.detailInfo.reserve_no
                }
            }).then(res => {
                const result = res.data.cancelReserveFromAdmin.result;
                this.process.result = '';
                this.process.resultText = '';
                if (result !== 0) {
                    this.cancelPoint();
                    this.closeRemoveOverLay();
                    this.getReserveDetail();
                } else {
                    throw new Error('エラーが発生しました');
                }
            }).catch(error => {
                this.process.result = '';
                this.process.resultText = '';
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * ポイントキャンセル
         * ---------------------------------------------- */
        cancelPoint () {
            let data = [{
                member_no: this.detailInfo.member_no.toString(),
                golf_code: this.input.golfCode,
                reserve_no: this.detailInfo.reserve_no
            }];
            this.$apollo.mutate({
                mutation: RESERVE_USE_POINT_CANCEL,
                variables: {
                    CancelPointByMemberNo: data
                }
            });
        },
        /** ------------ ----------------------------------
         * 削除ダイアログを表示する
         * ---------------------------------------------- */
        displayRemoveOverLay () {
            this.removeOverlay = true;
        },
        /** ----------------------------------------------
         * 削除ダイアログを閉じる
         * ---------------------------------------------- */
        closeRemoveOverLay (item) {
            this.process.result = '';
            this.removeOverlay = false;
        },
        /** ----------------------------------------------
         * 予約変更設定画面を表示する
         * ---------------------------------------------- */
        displayUpdateDialog () {
            this.updateInfoRefresh();
            this.$refs.UpdateListView.ModalControl(this.detailInfo.reserve_no);
        },
        showChange () {
            if (!this.changeReserveFlag) {
                this.changeReserveFlag = true;
            } else {
                this.changeReserveFlag = false;
            }
        },
        /** --------------------------------------------
        * 空がチェック
        * -------------------------------------------- */
        isEmpty (ele) {
            if (ele === ' ') {
                return null;
            }
            return ele;
        },
        /** ----------------------------------------------
         * 予約変更が完了した際に走る処理
         * 表示情報を更新する
         * ---------------------------------------------- */
        refresh () {
            this.getReserveDetail();
            this.updateInfoRefresh();
        },
        /** ----------------------------------------------
         * 予約変更の情報を更新する。
         * ---------------------------------------------- */
        updateInfoRefresh () {
            this.update.memberNo = this.detailInfo.member_no;
            this.update.reserveNo = this.detailInfo.reserve_no;
            this.update.playerMin = this.input.playerMin;
            this.update.playerMax = this.input.playerMax;
            this.update.planId = this.input.planId;
            this.update.cellId = this.input.cellId;
            this.update.playerLeft = this.input.playerLeft;
            this.update.golfCode = this.input.golfCode;
            this.update.reserveType = this.input.reserveType;
            this.update.planName = this.input.planName;
            this.update.playDate = this.input.playDate;
            this.update.telephone = this.input.telephone;
            this.update.memberClass = this.input.memberClass;
            this.update.playNumber = this.input.playNumber;
            this.update.groupNum = this.input.groupinfo.length;
            this.update.groupInfo = this.input.groupinfo;
            this.update.requestFirstChoice = this.isEmpty(this.input.requestFirstChoice);
            this.update.requestSecondChoice = this.isEmpty(this.input.requestSecondChoice);
            this.update.requestThirdChoice = this.isEmpty(this.input.requestThirdChoice);
            this.update.requestContactInfo = this.isEmpty(this.input.requestContactInfo);
        },
        /** ----------------------------------------------
         * メッセージ登録画面を表示する
         * ---------------------------------------------- */
        displayMessageDialog () {
            this.passTo.reserve_no = this.detailInfo.reserve_no;
            this.passTo.golfCode = this.input.golfCode;
            this.$refs.MessageListView.ModalControl(this.detailInfo.member_no);
        },
        /** ----------------------------------------------
         * 同伴者画面を表示する
         * ----------------------------------------------- */
        displayCompanion (contents) {
            this.editContents = contents;
            this.companionDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.detailInfo.reserve_no, false, this.input.planId, this.editContents);
        },
        /** ----------------------------------------------
         * 枠選択画面を表示する
         * ---------------------------------------------- */
        selectCellDialogOpen (info) {
            this.companionDialog = false;
            this.timeDialog = true;
            this.$refs.StartTimeModal.ModalControl(this.input.planId, this.input.playDate, this.input.reserveType, this.input.groupinfo, this.input.planId);
        },
        displaySelectPlanList () {
            this.$refs.SelectPlanModal.ModalControl(this.input.groupinfo);
            this.planDialog = true;
        },
        closePlanList () {
            this.planDialog = false;
        },
        /** ----------------------------------------------
         * 人数選択画面で正常終了したときに
         * 同伴者登録画面を表示する処理
         * ---------------------------------------------- */
        async successCompanionOpen (reserveNo) {
            await this.$refs.CompanionDialogView.OpenDialog(reserveNo, false, this.input.planId, 'changeCompanion');
            this.planDialog = false;
        },
        /** ----------------------------------------------
         * 変更ダイアログを閉じる
         * ---------------------------------------------- */
        closeChild (item) {
            this.companionDialog = false;
            this.planDialog = false;
            this.timeDialog = false;
            if (item) {
                this.cellIdList = item.selectCellId;
            }
        },
        closeCompanionModal () {
            this.companionDialog = false;
            this.refresh();
        },
        /** ----------------------------------------------
         * 人数選択画面を表示する
         * ---------------------------------------------- */
        timeDialogOpen () {
            this.timeDialog = true;
            this.$refs.StartTimeModal.ModalControl(this.input.planId, this.input.playDate, this.input.reserveType, this.input.groupinfo, this.input.planId);
        },
        successClose (reserveNo) {
            this.timeDialog = false;
            this.openVisitedModal();
        },
        openVisitedModal () {
            this.visitedDialog = true;
            this.$refs.CompanionDialogView.OpenDialog(this.detailInfo.reserve_no, false, this.input.planId, 'changeCompanion');
        },
        closeVisitedModal () {
            this.visitedDialog = false;
            this.refresh();
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        openModal () {
            this.dialog = true;
            this.reserve_no = this.detailInfo.reserve_no;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.changeReserveFlag = true;
            this.$emit('refresh-event');
        },
        /** ----------------------------------------------
         * 確認ダイアログの表示処理
         * ---------------------------------------------- */
        openChangeOverlay () {
            this.changeOverLay = true;
        },
        /** ----------------------------------------------
         * 確認ダイアログの閉じる処理
         * ---------------------------------------------- */
        closeChangeOverlay () {
            this.$set(this.process, 'result', '');
            this.changeOverLay = false;
        },
        /** ----------------------------------------------
         * 対応完了処理
         * ---------------------------------------------- */
        async updateComplete () {
            if (this.display_course) {
                this.displayingCd = 0;
            } else {
                this.displayingCd = 1;
            }
            await this.$apollo.mutate({
                mutation: UPDATE_DISPLAY_COURSE,
                variables: {
                    reserve_no: this.detailInfo.reserve_no,
                    display_course: this.displayingCd
                }
            }).then(res => {
                const result = res.data.UpdateDisplayCourse.result;
                this.$store.dispatch('auth/getMessageCount');
                this.$store.subscribe((mutation, state) => {
                    if (mutation.type === 'auth/setMessageCount') {
                        this.messageCount = this.$store.state.auth.messageCount;
                    }
                });
                if (this.displayingCd === 0) {
                    this.display_course = 1;
                } else {
                    this.display_course = 0;
                }
                if (result !== 0) {
                    this.closeChangeOverlay();
                    this.getReserveDetail();
                }
            }).catch(error => {
                this.error = error;
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', 'エラーが発生しました。');
            });
        }
    }
};
</script>

<style scoped>

.title{
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
}

.v-application .title {
    line-height: 3rem;
}

.titleContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableTitle{
    padding: 10px;
    border: solid 1px rgba(0,0,0, 0.12);
    border-radius: 10px;
    font-size: 20px;
    font-weight: bold;
}

.tableContainer{
    padding-right: 40px;
    padding-left: 40px;
}

.tableContainer .col{
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.button {
    justify-content: space-evenly;
}

.reserveChangeBtnWrap {
    display: flex;
    column-gap: 10px;
    background-color: gainsboro;
    padding: 10px 15px;
    margin-left: 14px;
}
</style>
